export default {
  data() {
    return {
      nameRules: [v => !!v || this.$t("nameIsRequire")],
      requireRules: [v => !!v || v===0 || this.$t("valueIsRequire")],
      phoneRules: [v => !!v && ((v+"").length<10 && (v+"").length>7) || this.$t("wrongNumber")],
      selectRules: [v => !!v || this.$t("pleaseChooseValue")],
      codeRules: [v => !!v || this.$t("codeIsRequire")],
      valueRules: [v => !!v || v===0 || this.$t("valueIsRequire")],
      dateRules: [v => !!v || this.$t("dateIsRequire")],
      dateRangeRules: [v => v.length>2 || this.$t("dateIsRequire")],
      userNameRules: [v => !!v || this.$t("usernameIsRequire")],
      passwordRules: [v => !!v || this.$t("passwordIsRequire")],
      requireAndNumber: [
        v => !! v.toString() || this.$t("valueIsRequire"),
        v => !! (Number(v) || Number(v) == 0) || this.$t("valueIsNumberOnly"),
      ],
      requireAndNumberAtleaseOne: [
        v => !! v.toString() || this.$t("valueIsRequire"),
        v => !! Number(v) && Number(v) > 0 || this.$t("valueIsNumberOnlyAndBiggerThanZero"),
      ],
      numberRules: [ v => !! (Number(v) || Number(v) == 0) || this.$t("valueIsNumberOnly")],
      phoneRulesOptional: [v => v === '' || ((v+"").length<10 && (v+"").length>7) || this.$t("wrongNumber")],
    };
  }
};
